module.exports = __webpack_public_path__ + "img/08.87f544be.jpg";